import PriceCampaignUpdateHandler from './PriceCampaignUpdateHandler'

export default PriceCampaignUpdateHandler
